import AdFormatsService from '@/api/admin/adFormats.service'

export default {
  state: {
    table: {
      rows: [],
      searchTerm: '',
    },
    adFormatId: 0,
  },
  getters: {
    allAdFormats: state => state.table,
    getAdFormatId: state => state.adFormatId,
  },
  actions: {
    async getAdFormats({ commit }, filter) {
      const adFormats = await AdFormatsService.getAdFormats(filter)
      commit('SET_AD_FORMATS', adFormats)
    },
  },
  mutations: {
    SET_AD_FORMATS(state, adFormats) {
      state.table.rows = adFormats
    },
    SET_AD_FORMAT_MODEL(state, adFormat) {
      state.adFormatId = adFormat.id
    },
  },
}
